import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import FormData from "form-data";
import { toast, ToastContainer } from "react-toastify";
import Layout from "./Layout";

export default function Register() {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const [userName, setUserName] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [surName, setSurname] = useState("");
  const [password, setPassword] = useState("");
  const [houseNo, setHouseNo] = useState(0);
  const [street, setStreet] = useState("");
  const [address, setAddress] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumbers, setMobileNumbers] = useState([""]);
  const [birthDate, setBirthdate] = useState("");
  const [dharmadaId, setDharmadaId] = useState("");
  const [loaded, setLoaded] = useState(false);
  const [image, setImage] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [mandalDetailsId, setMandalDetailsId] = useState("");
  const [mandals, setMandals] = useState([]);
  const [selectedMandal, setSelectedMandal] = useState(""); 

  const addMobileField = () => {
    if (mobileNumbers.length < 3) {
      setMobileNumbers([...mobileNumbers, ""]);
    }
  };

  const removeMobileField = (index) => {
    if (mobileNumbers.length > 1) {
      setMobileNumbers(mobileNumbers.filter((_, i) => i !== index));
    }
  };

  const handleMobileChange = (index, value) => {
    // Allow only numbers and limit to 10 digits
    if (/^\d{0,10}$/.test(value)) {
      const updatedMobiles = [...mobileNumbers];
      updatedMobiles[index] = value;
      setMobileNumbers(updatedMobiles);
    }
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file); // ✅ Store the actual file object
      setImagePreview(URL.createObjectURL(file)); // ✅ Display preview
    } else {
      setImage(null);
      setImagePreview(null);
    }
  };

  useEffect(() => {
    const fetchMandals = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/MandalDetails/GetPublicList`
        );
        setMandals(response.data.data);
      } catch (error) {
        console.error("Error fetching mandals:", error);
      }
    };

    fetchMandals();
  }, []);

  // Handle change in select field
  const handleSelectChange = (event) => {
    const selectedValue = event.target.value;
    setSelectedMandal(selectedValue);
    setMandalDetailsId(selectedValue); // Ensure MandalDetailsId is set correctly
  };

  const handleSubmit = async (e) => {
    setLoaded(true);
    e.preventDefault();

    const formData = new FormData();
    formData.append("MandalDetailsId", mandalDetailsId);
    formData.append("UserName", userName);
    formData.append("FirstName", firstName);
    formData.append("LastName", lastName);
    formData.append("surName", surName);
    formData.append("Password", password);
    formData.append("houseNo", houseNo);
    formData.append("street", street);
    formData.append("Address", address || "");
    formData.append("birthDate", birthDate || "");
    formData.append("dharmadaId", dharmadaId);
    formData.append("EmailId", email || "");
    formData.append("ContactNo", mobileNumbers[0]);
    formData.append("ContactNo1", mobileNumbers[1] || "");
    formData.append("ContactNo2", mobileNumbers[2] || "");
    formData.append("Date", new Date().toISOString().split("T")[0]);
    formData.append("IsVisible", "true");
    formData.append("type", "HariBhakt");
    formData.append("AttendenceStatus", false);
    if (image) {
      formData.append("image", image);
    }

    try {
      const response = await axios.post(
        `${apiUrl}/User/RegisterDetails`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );

      console.log(`Response: ${JSON.stringify(response.data.data)}`);

      if (response.data.status) {
        setLoaded(false);
        toast.success(response?.data?.message);
        setTimeout(() => {
          navigate("/manage");
        }, 3000);
      } else {
        toast.error(response?.data?.message);
      }
    } catch (error) {
      setLoaded(false);
      console.error("Error submitting form:", error);
    }
  };

  return (
    <>
      <Layout ac4="active">
        <section className="content-header pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-6">
                <h5>Haribhakt Registration</h5>
              </div>
            </div>
          </div>
        </section>
        <section className="content">
          <div className="container-fluid">
            <div className="card card-default">
              <div className="card-body">
                <form onSubmit={handleSubmit}>
                  {/* Mandal Selection */}
                  <div className="input-group mb-3">
                    <select
                      className="form-control"
                      style={{ cursor: "pointer" }}
                      required
                      id="mandalSelect"
                      value={selectedMandal} // Ensure this state is controlled
                      onChange={handleSelectChange}
                    >
                      <option value="" disabled>
                        Select Mandal
                      </option>
                      {mandals.map((mandal) => (
                        <option key={mandal.id} value={mandal.id}>
                          {mandal.name} ({mandal.description})
                        </option>
                      ))}
                    </select>
                    <div className="input-group-append">
                      <div className="input-group-text">
                        <span className="fas fa-users"></span>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="haribhaktFirstname">First Name</label>
                        <span className="text-danger">*</span>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="First Name"
                          value={firstName}
                          onChange={(e) => setFirstName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="haribhaktLastname">Middle Name</label>
                        <span className="text-danger">*</span>

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Middle Name"
                          value={lastName}
                          onChange={(e) => setLastName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="haribhaktSurname">Surname</label>
                        <span className="text-danger">*</span>

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Surname"
                          value={surName}
                          onChange={(e) => setSurname(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="haribhaktUsername">Username</label>
                        <span className="text-danger">*</span>

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Username"
                          value={userName}
                          onChange={(e) => setUserName(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="haribhaktPassword">Password</label>
                        <span className="text-danger">*</span>

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Password"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="haribhaktImage">Upload Image</label>
                      <div className="input-group mb-3">
                        <div className="form-control d-flex align-items-center justify-content-center">
                          <label
                            className="w-100 text-muted"
                            style={{ cursor: "pointer" }}
                          >
                            {image ? image.name : "Upload Profile Photo"}
                            <input
                              type="file"
                              accept="image/*"
                              onChange={handleImageChange}
                              hidden
                            />
                          </label>
                        </div>
                        <div className="input-group-append">
                          <div className="input-group-text">
                            <span className="fas fa-camera"></span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      {imagePreview && (
                        <div>
                          <label className="mr-3">Preview: </label>
                          <img
                            src={imagePreview}
                            alt="Selected file preview"
                            className="img-preview"
                          />
                        </div>
                      )}
                    </div>
                  </div>
                  {/* Mobile Number Fields */}
                  <label htmlFor="haribhaktMobileNumber">Mobile Number</label>

                  {mobileNumbers.map((number, index) => (
                    <div className="input-group mb-3" key={index}>
                      <input
                        type="text"
                        className="form-control"
                        placeholder={`Mobile Number ${index + 1}`}
                        value={number}
                        onChange={(e) =>
                          handleMobileChange(index, e.target.value)
                        }
                        required
                        pattern="\d{10}"
                        title="Enter a valid 10-digit mobile number"
                      />

                      <div className="input-group-append">
                        <button
                          type="button"
                          className="btn btn-primary d-flex align-items-center justify-content-center"
                          onClick={addMobileField}
                          disabled={mobileNumbers.length >= 3}
                          style={{ width: "40px" }}
                        >
                          <i className="fas fa-plus"></i>
                        </button>
                        {mobileNumbers.length > 1 && (
                          <button
                            type="button"
                            className="btn btn-danger d-flex align-items-center justify-content-center"
                            onClick={() => removeMobileField(index)}
                            style={{ width: "40px" }}
                          >
                            <i className="fas fa-minus"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  ))}

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="haribhaktHouseNo">House No.</label>
                        <span className="text-danger">*</span>

                        <input
                          type="text"
                          className="form-control"
                          placeholder="House No."
                          value={houseNo}
                          onChange={(e) => setHouseNo(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="haribhaktStreet">Street</label>
                        <span className="text-danger">*</span>

                        <input
                          type="text"
                          className="form-control"
                          placeholder="Street"
                          value={street}
                          onChange={(e) => setStreet(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="haribhaktAddress">Address</label>
                        <input
                          className="form-control"
                          placeholder="Enter Address"
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="haribhaktEmail">Email</label>
                        <input
                          type="email"
                          className="form-control"
                          placeholder="Email"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="haribhaktBirthdate">Birthdate</label>
                        <input
                          type="date"
                          className="form-control"
                          placeholder="Birthdate"
                          value={birthDate}
                          onChange={(e) => setBirthdate(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group">
                        <label htmlFor="haribhaktDharmadaId">Dharmada Id</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Dharmada Id"
                          value={dharmadaId}
                          onChange={(e) => setDharmadaId(e.target.value)}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="card-footer">
                    <div className="float-right">
                      <button
                        type="button"
                        className="btn btn-primary mx-2"
                        onClick={() => window.history.back()}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary"
                        disabled={loaded}
                      >
                        {loaded ? (
                          <>
                            <span
                              className="spinner-border spinner-border-sm"
                              role="status"
                              aria-hidden="true"
                            ></span>
                            Loading...
                          </>
                        ) : (
                          <>Register</>
                        )}
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
        <ToastContainer position="top-center" style={{ width: "auto" }} />
      </Layout>
    </>
  );
}
